import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
/** Join this component with Credit, to reuse custom content */
import React, { memo } from 'react';
export var ScriptSSR = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("script", _extends({
    suppressHydrationWarning: true
  }, attributes, {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(children)
    },
    type: "application/json"
  }));
}, function () {
  return true;
});